import React, { useState } from "react";

export default function StockAdjustment({ product, onConfirm, onCancel }) {
  const [quantity, setQuantity] = useState(0);
  const [type, setType] = useState("add");

  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm({ quantity: parseInt(quantity), type });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="block text-sm font-medium mb-1">Product: {product?.name}</label>
        <p className="text-sm text-gray-600">Current Stock: {product?.current_stock}</p>
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">Adjustment Type</label>
        <select value={type} onChange={(e) => setType(e.target.value)} className="w-full px-3 py-2 border rounded-lg">
          <option value="add">Add Stock</option>
          <option value="remove">Remove Stock</option>
          <option value="set">Set Stock</option>
        </select>
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">Quantity</label>
        <input type="number" value={quantity} onChange={(e) => setQuantity(e.target.value)} className="w-full px-3 py-2 border rounded-lg" required />
      </div>
      <div className="flex space-x-3">
        <button type="submit" className="btn-primary">Confirm</button>
        <button type="button" onClick={onCancel} className="btn-secondary">Cancel</button>
      </div>
    </form>
  );
}